import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@material-ui/core";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { Delete, Error } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import downloadAttachments from "../../../Functions/downloadAttachments";
import WarningBox from "../Components/WarningBox";
import OldDateWarning from "../NewInvoice/InvoiceGuidLines/OldDateWarning";

import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  uploadAdditioalDocumentFile,
  updateBuyerInvoice,
  getMethodForPageRefresh
} from "../actions";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import { ArrowBack } from "@material-ui/icons";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import { useNavigate } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";

import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import getParameterByName from "../../../Functions/functions";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import PoDetail_Table_Import from "../NewInvoice/Tables/PoDetail_Table_Import";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import Heading from "../../../StyledComponents/Heading/Heading";
import PageNotFound from "../NewInvoice/PageNotFound";
const useStyles = makeStyles(dashboardStyle);

const BuyerInvoice = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");
  // const vendorCode = getParameterByName("vendorCode");
  const invoicePayload = {
    Invoice_id: invoiceId,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [docError, setDocError] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(()=>{
    if(invoicePayload?.Invoice_id){
      getMethodForPageRefresh(invoicePayload?.Invoice_id,status,setAllowToProceed,setPageLoader)
    }
  },[invoicePayload?.Invoice_id,status])
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    po_Date: "",
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,

    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    // submission_Date: new Date(),
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    due_Date: new Date(),

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    verified: false,
  });

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [InvalidWarningDateState, setInvalidWarningDateState] = useState("");
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    //   for import invoice (extra field)
    currency: "",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    currency: "",

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const [debitBalance, setDebitBalance] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [invoiceTaxDetail, setInvoiceTaxDetail] = useState({
    invoice_TaxDetails: [],
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalGrnAmount, setTotalGrnAmount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);

  const ITEM_HEIGHT = 40;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    if (newFormState?.invoicePORef_List?.length > 0) {
      let counts = 0;
      for (let i = 0; i < newFormState?.invoicePORef_List?.length; i++) {
        const item = newFormState?.invoicePORef_List[i];
        counts = counts + parseFloat(item.inpuT_VAL);
      }
      setTotalGrnAmount(counts);
    }
  }, [newFormState.invoicePORef_List]);

  // to set po based true or false.
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);

  useEffect(() => {
    if (newFormState.pO_Based) {
      const tax_invAmt =
        parseFloat(newFormState?.salesTaxAmount) +
        parseFloat(newFormState?.invoice_Amount);
      const bal =
        Number(totalGrnAmount) +
        Number(newFormState?.salesTaxAmount || 0) +
        gLAccountTotal -
        Number(newFormState?.invoice_Amount || 0);
      const c = Number(bal.toFixed(3));
      setBalance(c);
    }
  }, [
    newFormState?.salesTaxAmount,
    newFormState?.invoice_Amount,
    totalGrnAmount,
    gLAccountTotal,
  ]);

  useEffect(() => {
    let debitt = 0;
    let creditt = 0;
    if (importPaymentDetail?.invoice_Payment_Details.length > 0) {
      for (
        let i = 0;
        i < importPaymentDetail?.invoice_Payment_Details?.length;
        i++
      ) {
        const ele = importPaymentDetail?.invoice_Payment_Details[i];
        if (ele.postingKey === "40") {
          // debit
          debitt = debitt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "50") {
          // credit
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "31") {
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
      }
      setDebitBalance(debitt);
      setCreditBalance(creditt);
    }
  }, [importPaymentDetail?.invoice_Payment_Details]);

  useEffect(() => {
    if (formState.invoice_Amount !== "") {
      setCreditBalance(formState.invoice_Amount);
    }
  }, [formState.invoice_Amount]);

  useEffect(() => {
    setBalance(creditBalance - debitBalance);
  }, [creditBalance, debitBalance]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
const [post ,setPost] = useState(true)
  const submitHandler = () => {
    const additionalDocIds = [];
    for (let i = 0; i < newFormState?.additionalDocIds?.length; i++) {
      const item = newFormState?.additionalDocIds[i];
      additionalDocIds.push(item?.path);
    }
    const data = {
      invoice_id: parseInt(newFormState.invoice_Id),
      additionalDocIds: additionalDocIds,
      comment: newFormState.comments,
      actionPerform: newFormState.buyer,
      updated_By: "",
    };
    updateBuyerInvoice(
      data,
      newFormState,
      setNewFormState,
      poBasedState,
      setErrorMessage,
      setSuccessMessage,
      setAttachInvoiceLoading,
      navigate,
      importPaymentDetail,
      setPost
    );
    setOpenWarningBox(false);
  };

  const [isFormStateStoped, setIsFormStateStoped] = useState(false);

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
    getRefrenceDataList("tType", "tType", setFormState, setMultipleData);

    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("Currency", "currency", setFormState, setMultipleData);
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      getInvoiceByInvoiceIdAndRoleId(
        invoicePayload,
        role,
        setFormState,
        () => {},
        () => {}
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      // if (!formState.isImport) {
      getAllInvoiceDetailByInvoiceId(
        setFormState,
        setMultipleData,
        invoicePayload?.Invoice_id,
        () => {},
        () => {},
        "",
        () => {}
      );
      // }
    }
  }, []);
  const [po_Loading, setPo_Loading] = useState(false);
  useEffect(() => {
    if (
      formState?.isImport &&
      formState?.pO_No &&
      formState?.invoicePORef_List?.length === 0
    ) {
      getImportPoData(
        formState?.pO_No,
        invoicePayload?.Invoice_id,
        setFormState,
        setPo_Loading
      );
    }
  }, [formState?.isImport, formState?.pO_No]);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
          newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  //  used for show taxdetail when invoice is created by import.

  //  used for show taxdetail when invoice is created by import.
  useEffect(() => {
    if (formState?.taxCard_List?.length > 0 && formState.isImport) {
      let tempArray = [];
      for (let i = 0; i < formState?.taxCard_List?.length; i++) {
        const item = formState?.taxCard_List[i];
        const obj = {
          taxId: 0,
          invoice_Id: invoicePayload?.Invoice_id,
          taxType: item?.taxType,
          taxCode: item?.taxCode,
          amount: formState.invoice_Amount,
          comments: "",
          created_By: "",
          created_On: new Date(),
          updated_By: "",
          updated_On: new Date(),
          taxCardId: 0,
        };
        tempArray.push(obj);
      }
      setInvoiceTaxDetail((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
    }
  }, [formState?.taxCard_List]);

  useEffect(() => {
    let total = 0;
    if (formState.invoice_Accounts.length > 0) {
      for (let index = 0; index < formState.invoice_Accounts.length; index++) {
        const item = formState.invoice_Accounts[index];
        total = parseFloat(item.amount ? item?.amount : item?.Amount) + total;
      }

      setGLAccountTotal(total);
    }
  }, [formState?.invoice_Accounts]);

  // invoice_attachment: "",
  // additionalDocIds: "", // paths

  // useEffect(() => {
  //   if (!changed && formState?.additionalDocIds.length > 0) {
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       additionalDocIds: [],
  //     }));
  //     setChanged(true);
  //   }

  // }, [formState.additionalDocIds]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const confirmHandler = (e) => {
    e.preventDefault();
    setOpenWarningBox(true);
  };
  const gltotal = 0;
  useEffect(() => {
    let days = multipleData?.paymentTerms?.filter(
      (item) =>
        item.ReferenceCode === newFormState.invoice_Payment?.paymentTerms
    );
    let date = moment(newFormState?.invoice_Date).format("YYYY-MM-DD");

    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        dueOn: moment(date, "YYYY-MM-DD")
          .add(Number(days[0]?.ReferenceProp1), "days")
          .format("YYYY-MM-DD"),
      },
    }));

    //  newFormState?.invoice_Payment
  }, [
    newFormState?.invoice_Payment?.paymentTerms,
    newFormState?.invoice_Payment?.dueOn,
    newFormState?.invoice_Date,
  ]);

  useEffect(() => {
    // if (newFormState.IsImport && newFormState.IsPSID) {
    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        paymentMethod: "6",
        paymentMethSupp: "C",
      },
    }));

    // }
    // else if (newFormState.IsImport && !newFormState.IsPSID) {
    //   setNewFormState((formState) => ({
    //     ...formState,
    //     invoice_Payment: {
    //       ...formState?.invoice_Payment,
    //       paymentMethod: '3',
    //       paymentMethSupp: 'P'

    //     },
    //   }))
    // }
  }, []);

  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [warningFlag, setWarningFlag] = useState(false);

  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState?.additionalDocIds?.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
        }));

        setdeleteLoader(false);
        setOpenWarningBox(false);
        setWarningFlag(false);
        setSuccessMessage(response?.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response?.data);
      });
  };
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  return (
    <>
    {/* {allowToProceed ?( */}
    <Card
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={dragloader || pageLoader}
      ></Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Buyer</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container style={{ marginTop: "4px", padding: "0px 5px" }}>
          {/* Submitter role */}
          <Grid item xs={12} sm={12} md={3} lg={3} mt={2}>
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span> Submitter Role
            </Typography>
            <Autocomplete
              id="submitter_role"
              options={roles}
              size="small"
              value={selectedRole}
              getOptionLabel={(option) =>
                (option !== "" && `${option?.roleName}`) || ""
              }
              loading={rolesLoading}
              onChange={(event, newValue) => {
                roleHandler(newValue);
              }}
              disabled
              renderInput={(params) => (
                <TextField {...params} type="text" name="" required />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
        </Grid>
        {!formState.isImport && (
          <InvoiceCheckboxes
            formState={formState}
            setFormState={setFormState}
            selectedRole="Buyer"
            disabled={true}
          />
        )}
        <Grid container style={{ padding: "0px 5px" }}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            {!formState.isImport && (
              <InvoiceRadioButtons
                formState={formState}
                setFormState={setFormState}
                selectedRole="Buyer"
                physicalOrEInvoice={physicalOrEInvoice}
                poBasedState={poBasedState}
                alignForAttachment={true}
              />
            )}
            <InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Buyer"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              setInvalidWarningDateState={setInvalidWarningDateState}
              multipleData={multipleData}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Typography
              variant="h5"
              component="h2"
              style={{ paddingLeft: "7px", marginTop: "20px" }}
            >
              <Heading title="Attachment Preview">
                <span>
                  {attachmentURL != ""
                    ? attachmentURL == formState?.invoice_attachment
                      ? " (Invoice Attachmnets)"
                      : "(Additional Documents)"
                    : null}
                </span>
              </Heading>
            </Typography>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>

        {/* Comment History */}
        <Grid container style={{ padding: "0px 5px" }}>
          <Grid item md={12} sm={12} xs={12} lg={12}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
        </Grid>
        <form onSubmit={confirmHandler} style={{ marginTop: "50 px" }}>
          {formState?.isImport && formState?.pO_Based ? (
            <PoDetail_Table_Import
              formState={newFormState}
              // setSelectedTotal={setSelectedTotal}
              setSelectedTotal={setTotalGrnAmount}
              setFormState={setNewFormState}
              deletee={true}
              Invoice_id={invoicePayload?.Invoice_id}
              checkedBox={false}
              loading={po_Loading}
            />
          ) : (
            <>
              {formState?.pO_Based && (
                <PODetail
                  formState={newFormState}
                  setFormState={setNewFormState}
                  disabled={true}
                  Invoice_id={invoicePayload?.Invoice_id}
                  setSelectedTotal={setTotalGrnAmount}
                />
              )}
            </>
          )}
          <Grid
            container
            spacing={2}
            style={{ marginBottom: "20px", padding: "0px 5px" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{
                display: edit == "false" ? "none" : "",
              }}
            >
              <FormControl fullWidth>
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span> Select Status
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="buyer"
                  id="demo-simple-select"
                  required={true}
                  // displayEmpty
                  label={newFormState.buyer === "" ? "Select a value" : ""}
                  value={newFormState.buyer}
                  onChange={changeHandler}
                  MenuProps={MenuProps}
                  InputLabelProps={{
                    shrink: false,
                    required: false,
                    className: classes.hs_form_required,
                  }}
                  select
                >
                  <MenuItem value="Resolved">Resolved</MenuItem>
                  <MenuItem value="Non-Resolved">Non-Resolved</MenuItem>
                </TextField>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{
                display: edit == "false" ? "none" : "",
              }}
            >
              <Typography style={{ color: "black" }}>
                Additional Documents
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                // onChange={() => }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={additionalAttachmentRef}
                        type="file"
                        name="additionalDocIds"
                        // accept=".png, .jpg, .jpeg, .pdf"
                        required={
                          newFormState?.isReject === false ? true : false
                        }
                        onChange={(e) =>
                          uploadAdditioalDocumentFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "additionalDocIds",
                            additionalAttachmentRef,
                            setDocError,
                            setAttachError,
                            setAlertMessage,
                            invoicePayload,
                            selectedRole,
                            dragfile,
                            setDragFile,
                            setSuccessMessage
                          )
                        }
                        style={{ width: "209px" }}
                        multiple
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {newFormState?.additionalDocIds?.length > 0 &&
                newFormState?.additionalDocIds?.map((f, index) => {
                  const s = f?.path.split("\\");
                  const ss = s[s.length - 1];
                  return (
                    <>
                      {f?.path !== "" ? (
                        <>
                          <Delete
                            color="danger"
                            fontSize="small"
                            style={{ cursor: "pointer" }}
                            // onClick={() => {
                            //   const files =
                            //     newFormState?.additionalDocIds?.filter(
                            //       (x, i) => {
                            //         const n = x.split("\\");
                            //         const nn = n[n.length - 1];
                            //         return nn !== ss;
                            //       }
                            //     );
                            //   setNewFormState((formState) => ({
                            //     ...formState,
                            //     additionalDocIds: files,
                            //   }));

                            //   //removing data from attachemt list for preview
                            //   let filtered_attachs = attachmentURLList?.filter(
                            //     (x) => x !== f
                            //   );
                            //   setAttachmentURLList(filtered_attachs);
                            //   setAttachmentURL(
                            //     filtered_attachs[filtered_attachs.length - 1]
                            //   );
                            // }}
                            onClick={() => {
                              setInvoiceDelete(f);
                              setWarningFlag(true);
                            }}
                          />

                          <Download
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const files =
                                newFormState?.additionalDocIds?.find((x, i) => {
                                  const n = x?.path?.split("\\");
                                  const nn = n[n.length - 1];
                                  return nn === ss;
                                });
                              downloadAttachments(files?.path);
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => {
                              const extension = f.path
                                ?.match(/\.[^.]+$/)[0]
                                .substring(1);
                              const allowedExtensions = [
                                ".png",
                                ".pdf",
                                ".jpg",
                                ".jpeg",
                                ".PNG",
                                ".JPG",
                                ".JPEG",
                                ".PNG",
                                ".PDF",
                              ];
                              const fileExtension = "." + ss.split(".").pop();
                              if (allowedExtensions.includes(fileExtension)) {
                                setAttachmentURL(f);
                              } else {
                                if (isContainEmailFormate(extension)) {
                                  downloadAttachments(f.path);
                                } else {
                                  setAttachmentURL(f);

                                  window.open(
                                    `${process.env.REACT_APP_API_URL}/${f.path}`,
                                    "_blank"
                                  );
                                }
                              }
                            }}
                          >
                            <span style={{ fontSize: "10px" }}>{ss}</span>
                          </IconButton>
                          <div></div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
            </Grid>
          </Grid>

          <Grid
            container
            style={{
              margin: "20px 0px",
              padding: "0px 5px",
              display: edit == "false" ? "none" : "",
            }}
          >
            <Grid item xs={12} sm={12} md={3} lg={12}>
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>
                comments
              </Typography>
              <TextField
                fullWidth
                multiline
                // rows={2}
                maxRows={4}
                // size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                name="comments"
                value={newFormState.comments}
                required
                onChange={changeHandler}
              />
            </Grid>
          </Grid>
          {((selectedRole?.roleName === "Buyer" ||
            selectedRole?.roleName === "PR Initiator") && post && allowToProceed) && (
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  style={{
                    margin: "2px",
                    color: "white",
                    display: edit == "false" ? "none" : "",
                  }}
                  variant="contained"
                  color="danger"
                  onClick={() => navigate("/home")}
                >
                  CANCEL
                </Button>

                {/* 
              <Button
                  style={{ margin: "2px", display: edit == "false" ? "none": ""}}
                  variant="contained"
                  color="inherit"
                  type="submit"

                  onClick={() => {
                    setConfirmationMessage(
                      "Are you sure to send invoice to Invoice Receiver"
                    );
                    setStatusForPayload("SendToIRFromBuyer");
                    setConfirmationModal(true);
                  }}
                >
                  Send to IR
                </Button> 
              */}
                <Button
                  style={{
                    margin: "2px",
                    display: edit == "false" ? "none" : "",
                  }}
                  variant="contained"
                  color="secondary"
                  type="submit"
                  onClick={() => {
                    if (selectedRole?.roleName === "Buyer") {
                      setStatusForPayload("SendToIRFromBuyer");
                    } else if (selectedRole?.roleName === "PR Initiator")
                      setStatusForPayload("SendToIRFromPRInitiator");
                  }}
                >
                  Send to IR
                </Button>
              </Grid>
            </Grid>
          )}
        </form>
      </CardBody>
      {openInvalidWarningDate && (
        <OldDateWarning
          open={openInvalidWarningDate}
          close={() => setOpenInvalidWarningDate(false)}
          InvalidWarningDateState={InvalidWarningDateState}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={submitHandler}
          loading={attachInvoiceLoading}
        />
      )}

      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <>
          {" "}
          <Grid container spacing={0}>
            <Grid item ml={4}>
              <Error
                titleAccess="Error"
                className={classes.asterisk}
                fontSize="small"
              />{" "}
            </Grid>
            <Grid item>
              <Typography className={classes.asterisk} ml={1}>
                {" "}
                {errorMessage}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          submit={submitHandler}
          message="Are you sure to send invoice to Invoice Receiver"
        />
      )}
      {warningFlag && (
        <WarningBox
          open={warningFlag}
          close={() => setWarningFlag(false)}
          submit={deleteAttachmentFunc}
          message="Are you sure to delete attachment"
          deleteLoader={deleteLoader}
          allow={1}
        />
      )}
      {alertMessage && (
        <POAlertDialog
          setAlertMessage={setAlertMessage}
          message={attachError ? attachError : docError}
          setErrAlertMessage={() => {}}
        />
      )}
    </Card>
       {/* ):(
      <PageNotFound/>
        )} */}
        </>
  );
};

export default BuyerInvoice;
